import { h } from "preact";
import "./Brand.scss";
import CouponComponent, { Coupon } from "../Coupons/Coupon/Coupon";

type BrandProps = {
  dailyDeals: Coupon[];
};

export function Brand({dailyDeals}: BrandProps) {
  return (
    <div class="brand-container">
        <h2>Daily Deals</h2>
        <div class={"deals-list"}>
          {dailyDeals.filter(b => b).map(coupon => <CouponComponent coupon={coupon}/>)}
        </div>
    </div>
  );
}
